import React, { useState, useCallback } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import styles from '../NavigationShell.styles';
import { FooterType } from 'configuration-schemas/general';
import { FooterTypeConfigs, FooterTypeRecord } from 'configuration-schemas/confdefn';
import { entries } from 'lodash';
import { classes } from 'typestyle';
import { FooterDrawer } from './FooterDrawer';

export interface FooterProps {
  footerTypes: FooterTypeRecord;
}

const NoneTypeFooterConfig: FooterTypeConfigs = { footerType: FooterType.none };

export const Footer = ({ footerTypes }: FooterProps) => {
  const [activeFooterType, setActiveFooterType] = useState<FooterTypeConfigs>(NoneTypeFooterConfig);

  const handleDrawerOpen = useCallback(
    (activeFooterType: FooterTypeConfigs) => setActiveFooterType(activeFooterType),
    [],
  );
  const handleDrawerClose = useCallback(() => setActiveFooterType(NoneTypeFooterConfig), []);
  const configItems = entries(footerTypes);

  return (
    <footer className={classes(styles.footerContainer, configItems.length > 0 ? 'footer-with-icons' : '')}>
      {configItems.map((entry) => {
        const [key, config] = entry;
        return (
          <Tooltip key={key} title={config.tooltip ?? ''}>
            <IconButton size="small" color="primary" disableRipple={true} onClick={() => handleDrawerOpen(config)}>
              <i className={classes(styles.footerInsightsIcon, 'fad fa-sparkles')}></i>
            </IconButton>
          </Tooltip>
        );
      })}
      {configItems.length > 0 ? (
        <FooterDrawer
          open={activeFooterType.footerType !== FooterType.none}
          activeFooterType={activeFooterType}
          footerTypes={footerTypes}
          onClose={handleDrawerClose}
        />
      ) : null}
    </footer>
  );
};
